//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import camelCase from 'camelcase';
import * as icons from 'gso-design-icons/vue/apps';
import {fetchme} from 'gso-fetchme';
import {read} from 'gso-session';

export default {
	name: 'app-link',
	props: ['id', 'title', 'url', 'isExternal', 'options'],
	computed: {
		icon() {
			return icons[camelCase(this.id, {pascalCase: true})];
		},
		// security issue with target="_blank", see https://mathiasbynens.github.io/rel-noopener/
		target() {
			return this.isExternal ? '_blank' : '_self';
		},
		rel() {
			return this.isExternal ? 'noopener noreferrer' : '';
		},
		href() {
			if (this.options && this.options === 'add_token') {
				return this.url + '&token=' + read('token');
			}

			return this.url;
		},
		isSaml() {
			return this.id === 'portal_citrix';
		},
		isBijster() {
			return this.id === 'bijster';
		}
	},
	methods: {
		samlAuth() {
			if (this.isSaml) {
				fetchme('/api/legacy/petrus/saml2/auth').then(data => {
					const form = document.querySelector('#formId');
					form.setAttribute('action', data.acsURL);
					const samlInput = document.querySelector('#SAMLResponse');
					samlInput.setAttribute('value', data.SAMLResponse);
					form.submit();
				});
			}
		},
		bijsterAuth() {
			if (this.isBijster) {
				fetchme('/api/legacy/petrus/bijster').then(data => {
					const bijsterBaseUrl = 'https://insights.groups.be/custom/sense/app/c7c7887b-07a6-42c8-8dd3-82a3e7ad07ef/sheet/3192aa0b-2c08-456c-9a65-417a8d2f79ef/state/analysis?qlikTicket=';
					window.open(bijsterBaseUrl + data.Ticket);
				});
			}
		}
	}
};
